import React from 'react';

const ToastNoticeWave = () => {
    return (
        <svg width='80' height='80' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <mask id='mask0_6113_89422' maskUnits='userSpaceOnUse' x='0' y='0' width='80' height='80'>
                <path d='M80 0H0V80H80V0Z' fill='white' />
            </mask>
            <g mask='url(#mask0_6113_89422)'>
                <g opacity='0.711538'>
                    <path
                        d='M39.7747 5.73047C58.8843 5.73047 74.4003 21.2453 74.4003 40.3549C74.4003 59.4645 58.8843 74.9793 39.7747 74.9793C20.6651 74.9793 5.15027 59.4645 5.15027 40.3549C5.15027 21.2453 20.6651 5.73047 39.7747 5.73047Z'
                        fill='#F4C10A'
                        fill-opacity='0.4'
                    />
                </g>
                <path
                    d='M40.0342 15.0864C53.7528 15.0864 64.8917 26.2245 64.8917 39.9431C64.8917 53.6618 53.7528 64.7998 40.0342 64.7998C26.3155 64.7998 15.1775 53.6618 15.1775 39.9431C15.1775 26.2245 26.3155 15.0864 40.0342 15.0864Z'
                    fill='#F4C10A'
                />
                <path
                    d='M40.0343 15.0859C53.7529 15.0859 64.8913 26.2244 64.8913 39.943C64.8913 53.6616 53.7529 64.8 40.0343 64.8C26.3157 64.8 15.1772 53.6616 15.1772 39.943C15.1772 26.2244 26.3157 15.0859 40.0343 15.0859Z'
                    stroke='#F4C10A'
                    stroke-width='2.44464'
                    stroke-miterlimit='1'
                    stroke-linecap='round'
                />
                <path d='M40.0358 24.8193V43.5532' stroke='white' stroke-width='4.4448' stroke-linecap='round' />
                <path d='M40.0358 51.7832C40.0358 51.9052 40.0358 51.9701 40.0358 51.9701' stroke='white' stroke-width='4.4448' stroke-linecap='round' />
            </g>
        </svg>
    );
};

export default ToastNoticeWave;
